import { Patch } from '../helpers';

type ToggleTestStreamResponse = {
  // Present only when the backend refuses the toggle (e.g. the previous live stream is still processing)
  message?: string;
};

export const PatchToggleTestStream = async (sessionUuid: string, testStream: boolean) => {
  return Patch<ToggleTestStreamResponse>({
    path: `/v3/admin/events/session/${sessionUuid}/test-stream`,
    body: { testStream },
  });
};
